<template>
    <div>
        <div style="position:fixed; left:0px; top:0px; width:100%; height:100%; background: rgba(33, 15, 3, 0.5);backdrop-filter: blur(5px); display:grid;place-items: center;">
            <template v-if="popup_type === SPLASH_POPUP_TYPE.DIRECT_MESSAGE">
                <div style="width:350px; height:400px; background-color: white; border-radius:24px; padding:20px; display:flex; flex-direction: column; position:relative;">
                    <img :src="require('@/assets/img/yellow_plus.png')" class="yellow_plus_size1" style="position:absolute;top:-75px; left:80px;">
                    <img :src="require('@/assets/img/yellow_plus.png')" class="yellow_plus_size1" style="position:absolute;top:-40px; left:220px;">
                    <img :src="require('@/assets/img/yellow_plus.png')" class="yellow_plus_size1" style="position:absolute;top:100px; left:50px;">
                    <img :src="require('@/assets/img/yellow_plus.png')" class="yellow_plus_size1" style="position:absolute;top:140px; left:20px;">
                    <img :src="require('@/assets/img/yellow_plus.png')" class="yellow_plus_size1" style="position:absolute;top:70px; left:280px;">
                    <img :src="require('@/assets/img/yellow_plus.png')" class="yellow_plus_size1" style="position:absolute;top:410px; left:40px;">
                    <img :src="require('@/assets/img/yellow_plus.png')" class="yellow_plus_size1" style="position:absolute;top:430px; left:300px;">
                    <img :src="require('@/assets/img/yellow_plus.png')" class="yellow_plus_size2" style="position:absolute;top:435px; left:80px; transform: rotate(45deg)">
                    <img :src="require('@/assets/img/yellow_plus.png')" class="yellow_plus_size2" style="position:absolute;top:170px; left:300px; transform: rotate(45deg)">
                    <div>
                        <div style="padding:5px 10px; font-size:16px; font-weight:bold;" @click="close">닫기</div>
                    </div>
                    <div style="flex:1;"></div>
                    <div style="display:grid; place-items: center;">
                        <ProfileImage :image-path="popup_data.from_member.image_path" style="width:100px; height:100px;" />
                    </div>
                    <div style="margin-top:20px;color:#210F03; font-size:20px; font-weight:bold; line-height:25px;text-align:center;">축하해요! {{ popup_data.from_member.nic_name }} 감독님에게<br>다이렉트 메시지를 받았어요</div>

                    <div style="display:grid;place-items: center;margin-top:40px; margin-bottom:20px;">
                        <div style=" background-color:black; color:white; height:40px; font-size:14px; font-weight:bold;display:grid;place-items: center; width:222px; border-radius:20px;" @click="confirm">확인</div>
                    </div>
                </div>

            </template>
            <template v-if="popup_type === SPLASH_POPUP_TYPE.REVIEW_CONFIRM">
                <div style="width:350px; height:260px; background-color: white; border-radius:24px; padding:40px 20px; display:flex; flex-direction: column; position:relative;">
                    <template v-if="$GlobalStore.loginInfo().is_temp_coach == 1">
                        <div style="color:#210F03; font-size:20px; font-weight:bold; line-height:25px;text-align:center;">트레이닝 후기를 보내주셨어요.<br>내용을 확인해보세요.</div>
                        <div style="display:grid; place-items: center; font-size:12px; color:#606060; line-height:20px;flex:1; text-align:center;">트레이닝의 좋았던 점과 다음 참여의향 및<br>한 줄 후기 내용을 확인해보세요.</div>
                        <div style="display:flex; gap:10px;">
                            <div style="flex:1;height:56px; display:grid;place-items: center; font-size:14px; font-weight:bold; background-color: #F5F5F5; color:#210F03; border-radius:50px;" @click="close">닫기</div>
                            <div style="flex:1;height:56px; display:grid;place-items: center; font-size:14px; font-weight:bold; background-color: #210F03; color:#FF7111; border-radius:50px;" @click="confirm">트레이닝 후기 보기</div>
                        </div>
                    </template>
                    <template v-else>
                        <div style="color:#210F03; font-size:20px; font-weight:bold; line-height:25px;text-align:center;">트레이닝이 종료됐습니다.<br>코치님에게 후기를 보내주세요!</div>
                        <div style="display:grid; place-items: center; font-size:12px; color:#606060; line-height:20px;flex:1; text-align:center;">언제든 후기를 보낼 수 있습니다.<br>하지만 생각이 난 지금 보내는 걸 추천해요.</div>
                        <div style="display:flex; gap:10px;">
                            <div style="flex:1;height:56px; display:grid;place-items: center; font-size:14px; font-weight:bold; background-color: #F5F5F5; color:#210F03; border-radius:50px;" @click="close">닫기</div>
                            <div style="flex:1;height:56px; display:grid;place-items: center; font-size:14px; font-weight:bold; background-color: #210F03; color:#FF7111; border-radius:50px;" @click="confirm">후기 보내기</div>
                        </div>
                    </template>

                </div>
            </template>

        </div>
    </div>
</template>

<script>
import ProfileImage from "../../common/ProfileImage";
import ResponseCode from "../../../ResponseCode";
import { REVIEW_PAGE_TYPE } from '@/Constants'

export const SPLASH_POPUP_TYPE = {
    DIRECT_MESSAGE: 0,
    REVIEW_CONFIRM: 1,
}

export default {
    name: "SplashPopup",
    components: { ProfileImage },
    props: {
        popup_type: {
            type: Number,
            defaultg: SPLASH_POPUP_TYPE.DIRECT_MESSAGE
        },
        popup_data: {
            type: Object,
            default: () => { }
        }
    },
    data() {
        return {
            SPLASH_POPUP_TYPE: SPLASH_POPUP_TYPE,
        }
    },
    methods: {
        close() {
            if (this.popup_type === SPLASH_POPUP_TYPE.DIRECT_MESSAGE) {
                this.saveDirectEessageConfirmed();
            } else if (this.popup_type === SPLASH_POPUP_TYPE.REVIEW_CONFIRM) {
                this.saveReviewConfirmed();
            }
            this.$GlobalStore.closeLastModal();
        },
        async saveReviewConfirmed() {
            const parameters = {};
            parameters.join_schedule_idx = this.popup_data.join_schedule_idx;
            parameters.member_idx = this.popup_data.member_idx;
            const res = await this.$Axios.post('/api/join/schedule/review/confirm', parameters);
            if (res.data.code === ResponseCode.FAIL) {
                this.$GlobalStore.showAlert(res.data.msg);
            }
        },
        async saveDirectEessageConfirmed() {
            const parameters = {};
            parameters.direct_message_idx = this.popup_data.idx;
            await this.$Axios.post('/api/direct_message/taken/confirm', parameters);
        },
        confirm() {
            if (this.popup_type === SPLASH_POPUP_TYPE.DIRECT_MESSAGE) {
                this.saveDirectEessageConfirmed();
                this.$router.push({ path: '/view/mychat?time=' + new Date().getTime() + '&is_direct_message=true' });
                this.$GlobalStore.closeLastModal();
            } else if (this.popup_type === SPLASH_POPUP_TYPE.REVIEW_CONFIRM) {
                this.saveReviewConfirmed();
                const join_schedule_idx = this.popup_data.join_schedule_idx;
                this.$GlobalStore.closeLastModal();

                if (this.$GlobalStore.loginInfo().is_temp_coach == '1') {
                    this.$GlobalStore.addModal('ReviewHistory', { join_schedule_idx: join_schedule_idx, member_idx : this.popup_data.member_idx, reviewPageType: REVIEW_PAGE_TYPE.RECEVIED })
                } else {
                    this.$GlobalStore.addModal('SendReview', { join_schedule_idx: join_schedule_idx})
                }
            }

        }
    },
    created() {
        this.confirm = this.$Once(this.confirm);
        this.close = this.$Once(this.close);
    }
}
</script>

<style scoped>
.yellow_plus_size1 {
    width: 18px;
    height: 18px;
}

.yellow_plus_size2 {
    width: 25px;
    height: 25px;
}
</style>